<template>
  <div class="bit" :style="computedStyle">
    <div class="bit-item"></div>
    <div class="bit-item"></div>
    <div class="bit-item"></div>
  </div>
</template>

<script>
export default {
  name: "bit",
  props: {
    width: {
      type: String,
      default: "24"
    },
    height: {
      type: String,
      default: "24"
    },
    direction: {
      // vertical 垂直
      // horizontal 水平
      type: String,
      default: "vertical"
    }
  },
  computed: {
    computedStyle() {
      let styleObj = {
        width: this.width + "px",
        height: this.height + "px"
      };
      if (this.direction === "vertical") {
        styleObj.flexDirection = "column";
      }
      return styleObj
    }
  },
  methods: {
    li(e) {
      // e.stopPropagation()
      // e.preventDefault()
    }
  }
}
</script>

<style lang="scss">
.bit {
  cursor: pointer;
  display: flex;
  justify-content: space-between;
  align-items: center;
  &:hover {
    .bit-item{
      background: $color-active;
    }
  }
}
.bit-item {
  position: relative;
  width: 2px;
  height: 2px;
  border-radius: 50%;
  background: initial;
}
</style>
